// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Tab_List__Item {\n  display: inline-block;\n  list-style: none;\n  margin-bottom: -1px;\n  padding: 0.5rem 0.75rem;\n  cursor: pointer; }\n  .Tab_List__Item .Icon {\n    margin-left: 10px; }\n\n.Tab_List__Active {\n  background-color: white;\n  border: solid #ccc;\n  border-width: 1px 1px 0 1px; }\n", ""]);
// Exports
module.exports = exports;
